import { Component, type ReactNode } from 'react';

/** Catches render crashes inside one view so a broken view shows an inline
 *  error card (with retry) instead of unmounting the whole app. Wrap each
 *  major surface (graph canvas, workflows, code, plots) with its own boundary
 *  — a crash in one leaves the others usable. */
export class ErrorBoundary extends Component<
  { label?: string; children: ReactNode },
  { error: Error | null }
> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error(`[ErrorBoundary]${this.props.label ? ` ${this.props.label}` : ''}`, error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="error-banner view-error" role="alert">
        <strong>{this.props.label ?? 'This view'} failed to render.</strong>
        <pre>{this.state.error.message}</pre>
        <div className="view-error-actions">
          <button type="button" className="btn" onClick={() => this.setState({ error: null })}>
            Try again
          </button>
          <button type="button" className="btn" onClick={() => window.location.reload()}>
            Reload app
          </button>
        </div>
      </div>
    );
  }
}
